import React from "react";


const ConfirmModal = ({ isOpen, title, message, onConfirm, onCancel,block }) => {

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center 
                 bg-[var(--black)] bg-opacity-70 px-4"
    >
      <div
        className="
          w-full max-w-md rounded-2xl p-6 text-center shadow-xl
          bg-[var(--black)] 
          text-[var(--yellow)]
          border-2 border-[var(--yellow)]
          animate-fadeIn
        "
      >
        {/* Title */}
        <h2 className="text-xl font-semibold mb-4 text-[var(--yellow)]">
          {title}
        </h2>

        {/* Message */}
        <p className="mb-6 text-[var(--yellow)] opacity-90">
          {message}
        </p>

        {/* Buttons */}
        <div className="flex justify-center gap-4">
          {/* Cancel */}
          <button
            onClick={onCancel}
            className="
              px-5 py-2 rounded-lg
              bg-[var(--black)] text-[var(--yellow)]
              border border-[var(--yellow)]
              hover:bg-[var(--yellow)] hover:text-[var(--black)]
              transition-all
            "
          >
            No
          </button>

          {/* Confirm */}
          <button
            onClick={onConfirm}
            className="
              px-5 py-2 rounded-lg
              bg-[var(--yellow)] text-[var(--black)]
              border border-[var(--black)]
              hover:opacity-80
              transition-all
            "
          >
            {
              `${block}`
            }
           
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;

